/**
 * This component is wrapper component for Outer layer integration.
 *
 * @module views/components/InterrupterCardContainer
 * @memberof -Common
 */
import './InterrupterCardContainer.scss';

import React from 'react';

import Modules from '@ulta/core/components/Modules/Modules';
import { hasItems } from '@ulta/core/utils/array/array';

/**
 * Represents a InterrupterCardContainer component
 *
 * @method
 * @param {object} props - React properties passed from composition
 * @returns InterrupterCardContainer
 */
export const InterrupterCardContainer = function( props ){
  const { modules } = props;

  if( !hasItems( modules ) ){
    return null;
  }

  return (
    <div className='InterrupterCardContainer'>
      <Modules modules={ modules } />
    </div>
  );
};

InterrupterCardContainer.displayName = 'InterrupterCardContainer';

export default InterrupterCardContainer;
